export { default } from './PreImg'
export * from './types';
